import type { Token } from '$lib/interfaces';
import { withDependencies, getResponseErrorCode } from '$lib/api';
import type { PageLoad } from './$types';
import { error } from '@sveltejs/kit';
import { getMultichainBalances } from '$lib/bitski-tokens';

export const _ITEMS_RENDERED = 100;

export const load: PageLoad = ({ url, fetch, parent }) => {
  return withDependencies(async () => {
    const { addresses } = await parent();
    const pageParam = Number(url.searchParams.get('page'));
    const chainIds = url.searchParams.get('chainIds') ?? undefined;
    const currentPage = isNaN(pageParam) ? 1 : Math.max(pageParam, 1);

    const limit = _ITEMS_RENDERED;
    const offset = (currentPage - 1) * limit;

    try {
      const tokens: Token[] | undefined = addresses
        ? await getMultichainBalances(fetch, { addresses, chainIds, offset, limit })
        : [];

      return {
        tokens,
        currentPage,
      };
    } catch (e) {
      if (getResponseErrorCode(e) === 404) {
        console.warn('balances not found');
        throw error(404);
      }

      return {
        currentPage,
      };
    }
  });
};
